import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

// eslint-disable-next-line import/prefer-default-export
export const getWarmingUpStatus = async () => {
  const response = await axiosMethods.get(RestAPI.WARMING_UP_STATUS);
  return response;
};
